export default "__VITE_ASSET__BLG$LX$1__"